var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconoSend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_412_365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.73318 23.7235C7.37062 23.688 7.00536 23.7549 6.67897 23.9167C6.35258 24.0785 6.07815 24.3287 5.8869 24.6388C5.69565 24.9488 5.59525 25.3063 5.59714 25.6706C5.59902 26.0349 5.70311 26.3914 5.89756 26.6994L17.7562 42.3724C17.9773 42.6644 18.2763 42.8882 18.6188 43.0179C18.9613 43.1477 19.3335 43.1781 19.6926 43.1058L41.7021 38.6398C42.7501 38.4589 43.2852 39.8546 42.385 40.4208L23.0318 51.8145C22.7164 52.0008 22.46 52.2722 22.292 52.5977C22.124 52.9232 22.0513 53.2895 22.0821 53.6545L23.7419 73.238C23.8033 73.5971 23.9642 73.9318 24.2063 74.2039C24.4485 74.4761 24.7622 74.6748 25.1117 74.7775C25.4612 74.8803 25.8325 74.8828 26.1834 74.7849C26.5343 74.687 26.8507 74.4926 27.0966 74.2238L65.2888 32.4809C65.5323 32.2142 65.6969 31.885 65.764 31.5301C65.8311 31.1753 65.7982 30.8088 65.6689 30.4716C65.5396 30.1343 65.319 29.8398 65.0319 29.6208C64.7447 29.4017 64.4023 29.267 64.0429 29.2315L7.73318 23.7235Z",
    fill: "#164453"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_412_365"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62.2834,
    height: 62.2834,
    fill: "white",
    transform: "translate(0 22.2988) rotate(-20.9784)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoSend);
export default __webpack_public_path__ + "static/media/icono_send.128be0d59ba6b56fbb9014e17bf84188.svg";
export { ForwardRef as ReactComponent };